import type { Catalogue } from "../i18n";

export const CL: Catalogue = {
  "failed": "falló, qué fome",
  "saving": "guardando",
  "waiting": "esperando",
  "today": "hoy",
  "yesterday": "ayer",
  "{days}d": "{days} d",
  "{weeks}w": "{weeks} sem",
  "unlabeled": "sin nombre",
  "untagged": "sin etiquetas",
  "loading more": "cargando más",
  "that's all {count}": "son todos, {count}",
  "shuffled": "mezclado",
  "nothing to show": "no hay na' que mostrar",
  "chi is looking again": "chi vuelve a mirar, al tiro",
  "chi is looking at this one next": "chi mirará esta a continuación",
  "could not index that ref": "no se pudo indexar esa ref, qué lata",
  "details": "detalles",
  "clips are not described, write your own": "los clips no se describen, escribe la tuya po",
  "chi left this one ({reason}), write your own": "chi se saltó esta ({reason}), escribe la tuya po",
  "chi is looking at this…": "chi está echándole una mirada a esto…",
  "not described yet, write your own or tap spark": "aún sin descripción, escribe la tuya o toca la chispa",
  "saved": "guardado",
  "could not save the description": "no se pudo guardar la descripción",
  "chi skips clips": "chi se salta los clips",
  "described": "descrita",
  "chi is looking": "chi está mirando",
  "skipped": "saltada",
  "waiting on chi": "esperando a chi",
  "tagging {done}/{total} · {left} left": "etiquetando {done}/{total} · quedan {left}",
  "tagged {done}/{total} · {left} left": "etiquetadas {done}/{total} · quedan {left}",
  "all {total} tagged": "las {total} etiquetadas",
  "{shown} of {total}": "{shown} de {total}",
  "{count} adding": "{count} agregándose",
  "{count} failed": "{count} fallidas",
  "{count} to describe": "{count} por describir",
  "busy": "ocupada, un toque",
  "tag": "etiqueta",
  "tap + to add pictures, drop files here, or use + ref in chrome": "toca + para agregar imágenes, suelta archivos acá o usa + ref en chrome",
  "every ref already has your note": "todas las refs ya tienen tu nota",
  "nothing matches": "no calza nada",
  "could not load references": "no se pudieron cargar las referencias",
  "video": "video",
  "all described": "todo descrito",
  "could not read that file": "no se pudo leer ese archivo",
  "nothing usable there": "no hay nada que sirva ahí",
  "adding {count}": "agregando {count}",
  "could not import that file": "no se pudo importar ese archivo",
  "showing {tag}": "mostrando {tag}",
  "chi is tagging {count} refs": "chi está etiquetando {count} refs",
  "every ref is tagged": "todas las refs están etiquetadas",
  "could not start tagging": "no se pudo empezar a etiquetar",
  "delete this reference?": "¿borrar esta referencia?",
  "ref saved": "ref guardada, bacán",
  "ref save failed": "no se pudo guardar la ref",
  "tagging done": "etiquetado listo, filete",
  "mode": "modo",
  "tools": "herramientas",
  "Tools": "Herramientas",
  "Talk to Chi": "Hablar con Chi",
  "mode tuner, drag or tap a station": "sintonizador de modo, arrastra o toca una emisora",
  "Tool": "Herramienta",
  "Chi · direct line": "Chi · línea directa",
  "{name}'s {what} · read only": "{what} de {name} · solo lectura",
  "could not open a print sheet": "no se pudo abrir una hoja de impresión",
  "never": "nunca jamás",
  "could not shrink that picture": "no se pudo reducir esa imagen",
  "could not read that picture": "no se pudo leer esa imagen",
  "chix is processing": "chix está procesando",
  "What should I work on next?": "¿En qué debería pegarme ahora?",
  "nothing yet": "nada por ahora",
  "where it came from": "de dónde salió",
  "rent, phone…": "arriendo, teléfono…",
  "what was it": "qué fue",
  "mine": "mío",
  "{name}'s": "de {name}",
  "added to {name}'s budget": "agregado al presupuesto de {name}",
  "added to your budget": "agregado a tu presupuesto",
  "couldn't add that": "no se pudo agregar, qué lata",
  "login with discord": "entra con discord",
  "minipi #{id}": "minipi n.º {id}",
  "a minipi": "un minipi",
  "{who} says": "{who} dice",
  "{who} · art tip": "{who} · consejo de arte",
  "pings": "avisos",
  "Late shift, {name}.": "Turno de noche, {name}, ánimo.",
  "Morning, {name}.": "Buenos días, {name}.",
  "Ready when you are, {name}.": "Lista cuando querai, {name}.",
  "Evening, {name}.": "Buenas tardes, {name}.",
  "signal": "señal",
  "sweet": "dulce",
  "edge": "filo",
  "dark fog, film grain and chi's cyan": "niebla oscura, grano de película y el cian de chi",
  "pale daytime fog, ink and deep teal": "niebla pálida de día, tinta y verde azulado profundo",
  "silent hill ash and an orange coal": "ceniza de silent hill y una brasa naranja",
  "deep water, teal fog, a sonar ping": "agua profunda, niebla verde azulada, un ping de sonar",
  "rose paper and a hot pink signal": "papel rosa y una señal rosa intenso",
  "peach cream and a coral signal": "crema de durazno y una señal coral",
  "mint milk with strawberry pink": "leche de menta con rosa fresa",
  "magical girl night, violet fog, bubblegum pink": "noche de chica mágica, niebla violeta, rosa chicle",
  "midnight sky in periwinkle and pink": "cielo de medianoche en azul lavanda y rosa",
  "the otherworld: rust black and blood red": "el otro mundo: negro óxido y rojo sangre",
  "night city chrome, warning yellow, red glitch": "cromo de ciudad nocturna, amarillo de alerta, glitch rojo",
  "bruise purple fog and acid lime": "niebla morado moratón y lima ácida",
  "pure black and white, no mercy": "blanco y negro puro, sin piedad",
  "green crt, memory card manager at 2am": "crt verde, gestor de memory card a las 2am",
  "amber crt terminal, warm glow": "terminal crt ámbar, brillo cálido",
  "cream sketch paper and flipnote orange": "papel de boceto crema y naranja flipnote",
  "grey console, blue memory card screen": "consola gris, pantalla azul de memory card",
  "four shades of handheld green": "cuatro tonos de verde portátil",
  "none": "ninguno",
  "scanlines": "líneas de escaneo",
  "grid": "cuadrícula",
  "dots": "puntos",
  "notebook": "cuaderno",
  "checker": "cuadros",
  "crosshair": "mira",
  "sparkles": "destellos",
  "hazard": "peligro",
  "starry sky": "cielo estrellado",
  "falling leaves": "hojas cayendo",
  "sakura petals": "pétalos de sakura",
  "snow": "nieve",
  "rain": "lluvia",
  "fireflies": "luciérnagas",
  "moves gently, stays still with calm motion": "se mueve suave, se queda quieto con movimiento suave",
  "pattern on": "patrón activado",
  "theme on": "tema activado",
  "saved, type to replace": "guardada, escribe pa' reemplazar",
  "not set": "sin configurar",
  "token copied": "token copiado",
  "make a new extension token? the old one stops working until you paste the new one in": "¿crear un nuevo token de extensión? el viejo deja de funcionar hasta que pegues el nuevo",
  "new token made": "nuevo token creado",
  "log out of chix on every device?": "¿cerrar sesión de chix en todos los dispositivos?",
  "$ dollar": "$ dólar",
  "£ pound": "£ libra",
  "C$ canadian": "C$ canadiense",
  "A$ australian": "A$ australiano",
  "CHF swiss franc": "CHF franco suizo",
  "talking to plane": "hablando con plane",
  "connected to {workspace}, now pick your boards": "conectado a {workspace}, ahora elige tus tableros",
  "open plane": "abrir plane",
  "in safari, create an api token in profile settings, paste it below, then save": "en safari, crea un token de api en ajustes del perfil, pégalo abajo y guarda",
  "couldn't do that": "no se pudo, qué fome",
  "google turned the map key away. check it's allowed on this site and maps javascript api is on": "google rechazó la clave del mapa. revisa que esté permitida en este sitio y que maps javascript api esté activada",
  "the map needs a key to draw, searches and routes still work below": "el mapa necesita una clave para dibujarse, las búsquedas y rutas siguen funcionando abajo",
  "the map couldn't load. searches and routes still work below": "el mapa no pudo cargar. las búsquedas y rutas siguen funcionando abajo",
  "you": "tú",
  "new pin": "nuevo pin",
  "open now": "abierto ahora",
  "closed now": "cerrado ahora",
  "new": "nuevo",
  "{rating} from 1 review": "{rating} de 1 reseña",
  "{rating} from {count} reviews": "{rating} de {count} reseñas",
  "no reviews yet": "aún no hay reseñas",
  "no parking info": "sin info de estacionamiento",
  "no parking listed": "no hay estacionamiento indicado",
  "{place} is stop {letter}": "{place} es la parada {letter}",
  "save": "guardar",
  "looking…": "buscando…",
  "nothing found there. try further out or other words": "no se encontró nada ahí. prueba más lejos u otras palabras",
  "pick something to look for, or search above": "elige algo que buscar o busca arriba",
  "{what} within {distance} of {place}": "{what} a menos de {distance} de {place}",
  "around {place}": "cerca de {place}",
  "ten stops is the most": "diez paradas es el máximo",
  "taken out of saved": "sacado de guardados",
  "remove {name}?": "¿sacar {name}?",
  "nothing saved yet": "aún no hay nada guardado",
  "tap the map": "toca el mapa",
  "drop a pin": "poner un pin",
  "edit {name}": "editar {name}",
  "save pin": "guardar pin",
  "my pin": "mi pin",
  "pinned": "fijado",
  "places, ratings, parking and routes come from google maps. it needs a key from your google cloud account, google gives a free allowance each month": "los lugares, valoraciones, estacionamiento y rutas vienen de google maps. necesita una clave de tu cuenta de google cloud, google da un uso gratis cada mes",
  "fractal hasn't added a google maps key yet, so the map can't look anything up": "fractal aún no ha agregado una clave de google maps, así que el mapa no puede buscar nada",
  "within {distance}": "a menos de {distance}",
  "this area": "esta zona",
  "couldn't find where you are, staying around {place}": "no se pudo encontrar dónde estás, sigo cerca de {place}",
  "cyan": "cian",
  "violet": "violeta",
  "amber": "ámbar",
  "green": "verde",
  "red": "rojo",
  "tap the map where the pin goes": "toca el mapa donde va el pin",
  "couldn't find where you are": "no se pudo encontrar dónde estás",
  "take this pin off the map?": "¿quitar este pin del mapa?",
  "where i am": "donde ando",
  "home ({place})": "casa ({place})",
  "name this route": "ponle nombre a esta ruta",
  "{from} to {to}": "{from} a {to}",
  "route saved": "ruta guardada",
  "food": "comida",
  "pubs and bars": "copete y carrete",
  "takeaway": "pa' llevar",
  "shops": "tiendas",
  "fuel": "bencina",
  "parking": "estacionamiento",
  "pharmacy": "farmacia",
  "parks": "parques",
  "things to see": "cosas pa' ver",
  "cinema": "cine",
  "ev charging": "carga de autos eléctricos",
  "drive": "auto",
  "walk": "a pata",
  "cycle": "bici",
  "bus/train": "micro/metro",
  "{amount} a month": "{amount} al mes",
  "by {date}": "para el {date}",
  "monthly, stopped {date}": "mensual, parado el {date}",
  "monthly from {date}": "mensual desde {date}",
  "on {date}": "el {date}",
  "added by you": "agregado por ti",
  "added by {name}": "agregado por {name}",
  "{done} paid of {total} · {left} left": "{done} pagado de {total} · quedan {left}",
  "paid off · {total}": "pagado completo · {total}",
  "{done} saved of {total} · {left} to go": "{done} ahorrado de {total} · faltan {left}",
  "reached · {done}": "logrado · {done}, bacán",
  "in": "entra",
  "bill": "cuenta",
  "cost": "gasto",
  "debt": "deuda",
  "goal": "meta",
  "remove {name}? its history goes too": "¿quitar {name}? su historial también se va",
  "restart": "reiniciar",
  "stop": "parar",
  "paid": "pagado",
  "payment logged": "pago anotado",
  "saved toward it": "ahorrado para ello",
  "took back the last one": "se deshizo el último",
  "{amount} left": "quedan {amount}",
  "{amount} saved": "{amount} ahorrado",
  "out": "sale",
  "no monthly bills yet": "aún no hay cuentas mensuales",
  "owe": "debo",
  "{percent}% of {total}": "{percent}% de {total}",
  "{amount} this month": "{amount} este mes",
  "owed in total": "debido en total",
  "target": "objetivo",
  "a month (optional)": "al mes (opcional)",
  "how much comes in": "cuánto entra",
  "how much": "cuánto",
  "by": "para el",
  "since": "desde",
  "from": "desde",
  "on": "el",
  "where it comes from": "de dónde viene",
  "rent, phone, adobe…": "arriendo, teléfono, adobe…",
  "what you bought": "qué compraste",
  "who or what you owe": "a quién o qué le debes",
  "what you're saving for": "pa' qué estai ahorrando",
  "add": "agregar",
  "add to the budget": "agregar al presupuesto",
  "added": "agregado",
  "couldn't save that": "no se pudo guardar eso",
  "due: {title}": "vence: {title}",
  "unexpected \"{char}\"": "\"{char}\" inesperado",
  "missing )": "falta )",
  "expected a number": "se esperaba un número",
  "that goes to infinity": "eso se va al infinito",
  "not set, add it in setup": "sin poner, añádela en ajustes",
  "{spent} of {budget} for tagging": "{spent} de {budget} para etiquetar",
  "no cap on tagging": "sin límite de etiquetado",
  "{count} refs waiting since {time}": "{count} refs esperando desde las {time}",
  "none running": "nada en marcha",
  "{calls} calls · {input} in · {cached} cached · {output} out": "{calls} llamadas · {input} entrada · {cached} en caché · {output} salida",
  "nothing yet for {month}": "aún nada para {month}",
  "{calls} calls": "{calls} llamadas",
  "split starts with the next answer": "el reparto parte con la próxima respuesta",
  "could not read claude usage": "no se pudo leer el uso de claude",
  "all": "todo",
  "start {name}?": "¿partir {name}?",
  "starting {name}...": "partiendo {name}...",
  "{name} start sent": "partida de {name} enviada",
  "stop {name}?": "¿parar {name}?",
  "stopping {name}...": "parando {name}...",
  "{name} stop sent": "parada de {name} enviada",
  "restart {name}?": "¿reiniciar {name}?",
  "restarting {name}...": "reiniciando {name}...",
  "{name} restart sent": "reinicio de {name} enviado",
  "running": "en marcha",
  "stopped": "parado",
  "crash looping": "cayéndose en bucle, cuático",
  "starting": "partiendo",
  "up {time}": "activo {time}",
  "{count} restarts": "{count} reinicios",
  "{name} logs": "registros de {name}",
  "loading...": "cargando...",
  "{used} of {total}": "{used} de {total}",
  "could not reach the server: {error}": "no se pudo conectar con el servidor: {error}",
  "validating caddy...": "validando caddy...",
  "caddy reloaded": "caddy recargado",
  "{label}, one per line": "{label}, uno por línea",
  "change picture": "cambiar imagen",
  "all {n}": "todo {n}",
  "unsorted": "sin ordenar",
  "under a cent": "menos de una luca (ni cerca)",
  "chi looking {done}/{total}": "chi mirando {done}/{total}",
  "chi look {done}/{total}": "chi mira {done}/{total}",
  "chi looked": "chi ya miró",
  "chi has looked at every character picture": "chi ya miró todas las imágenes de personajes",
  "{n} more wait for another press.": "{n} más esperan otro toque.",
  "chi has looked at {done} of {total} character pictures. look at the next {count} for about {price}? it goes through the half price batch, so it can take a while.": "chi ha mirado {done} de {total} imágenes de personajes. ¿mirar las siguientes {count} por unos {price}? va por el lote a mitad de precio, así que puede tardar.",
  "chi is looking at {count} pictures": "chi está mirando {count} imágenes",
  "could not start chi": "no se pudo partir chi",
  "chi looks at 1 picture of {name} she hasn't seen, about {price}?": "¿chi mira 1 imagen de {name} que no ha visto, por unos {price}?",
  "chi looks at {count} pictures of {name} she hasn't seen, about {price}?": "¿chi mira {count} imágenes de {name} que no ha visto, por unos {price}?",
  "chi has seen all {total} pictures of {name}. look at them again from scratch, about {price}?": "chi ya vio las {total} imágenes de {name}. ¿mirarlas otra vez desde cero, por unos {price}?",
  "chi is looking at {name}": "chi está mirando a {name}",
  "picture {n}": "imagen {n}",
  "adding 1 picture…": "agregando 1 imagen…",
  "adding {n} pictures…": "agregando {n} imágenes…",
  "picture added": "imagen agregada",
  "{n} pictures added": "{n} imágenes agregadas",
  "could not add the picture": "no se pudo agregar la imagen",
  "take this picture off the character?": "¿quitar esta imagen del personaje?",
  "picture removed": "imagen quitada",
  "could not remove the picture": "no se pudo quitar la imagen",
  "sheet picture changed": "imagen de ficha cambiada",
  "could not change the picture": "no se pudo cambiar la imagen",
  "fetching characters from {source}…": "trayendo personajes de {source}…",
  "{n} found": "{n} encontrados",
  "{n} added": "{n} agregados",
  "{n} updated": "{n} actualizados",
  "{n} duplicates merged": "{n} duplicados fusionados",
  "{n} failed": "{n} fallidos",
  "{source} import failed": "falló la importación de {source}",
  "aka {names}": "alias {names}",
  "{n} pictures": "{n} imágenes",
  "merge into {name}": "fusionar con {name}",
  "merge {other} into {name}? {other}'s sheet goes away and its pictures move to {name}.": "¿fusionar {other} con {name}? la ficha de {other} desaparece y sus imágenes pasan a {name}.",
  "{other} merged into {name}": "{other} fusionado con {name}",
  "the sheet": "la ficha",
  "could not merge": "no se pudo fusionar",
  "character saved": "personaje guardado",
  "could not save": "no se pudo guardar",
  "delete {name}?": "¿borrar {name}?",
  "1 block today": "1 bloque hoy",
  "{n} blocks today": "{n} bloques hoy",
  "resume": "seguir",
  "back to drawing": "de vuelta a dibujar",
  "break time, stretch your hand": "hora de descanso, estira la mano po",
  "focus block started": "bloque de concentración empezado",
  "take a break": "tómate un descanso, ya po",
  "type minutes, like 40 or 1h30": "escribe minutos, como 40 o 1h30",
  "drop this picture": "sacar esta imagen",
  "toss {hex}?": "¿botar {hex}?",
  "copied {hex}": "{hex} copiado",
  "prompt copied": "prompt copiado",
  "commissions": "encargos",
  "no commissions": "sin encargos",
  "comms money": "plata de encargos",
  "{n} paid": "{n} pagados",
  "{n} others": "{n} más",
  "nothing paid yet": "aún no pagan na'",
  "that task is done or gone": "esa tarea ya está hecha o no existe",
  "unlink {title}": "desvincular {title}",
  "no task matches": "ninguna tarea calza",
  "no open tasks. add one in tasks first": "no hay tareas abiertas. agrega una en tareas primero",
  "for {client}": "para {client}",
  "paid {day}": "pagado {day}",
  "due {date}": "vence {date}",
  "commission saved": "encargo guardado",
  "commission added": "encargo agregado",
  "break": "descanso",
  "unknown": "desconocido",
  "fapped {n} times": "fap {n} veces",
  "no doodles match": "ningún garabato coincide",
  "could not load the doodles": "no se pudieron cargar los garabatos",
  "no picture on the clipboard": "no hay imagen en el portapapeles",
  "pick a picture": "elige una imagen",
  "you can look at the doodles, not add them": "puedes mirar los garabatos, pero no agregarlos",
  "adding the doodle": "agregando el garabato",
  "adding {n} of {total}": "agregando {n} de {total}",
  "{n} doodles added": "{n} garabatos agregados",
  "could not add that": "no se pudo agregar eso",
  "press ctrl+v or ⌘v to paste": "aprieta ctrl+v o ⌘v para pegar",
  "couldn't read the clipboard, try ctrl+v or ⌘v": "no se pudo leer el portapapeles, prueba ctrl+v o ⌘v",
  "gone": "ya no está",
  "remove {name}": "sacar a {name}",
  "new doodle": "nuevo garabato",
  "doodle saved": "garabato guardado",
  "delete this doodle?": "¿borrar este garabato?",
  "could not delete": "no se pudo borrar",
  "by {name}": "de {name}",
  "one a day per doodle, come back tomorrow": "uno al día por garabato, vuelve mañana po",
  "today ✓ {n}": "hoy ✓ {n}",
  "fapped {n}×": "fap {n}×",
  "you {n}": "tú {n}",
  "could not count that": "no se pudo contar eso",
  "random full body poses from the pocketbase library": "poses de cuerpo entero al azar de la biblioteca pocketbase",
  "{n} refs in the pool": "{n} refs en el grupo",
  "no refs match yet": "aún no coincide ninguna ref",
  "could not fetch poses": "no se pudieron traer poses",
  "play": "seguir",
  "no poses to draw from": "no hay poses pa' dibujar",
  "{n} poses done, nice": "{n} poses listas, bacán",
  "{n} answered today": "{n} respondidas hoy",
  "{n} day streak": "racha de {n} días",
  "nothing due right now, {n} learning cards come back in {minutes}m": "nada pendiente ahora, {n} tarjetas en aprendizaje vuelven en {minutes}m",
  "today's cards are done, see you tomorrow": "las tarjetas de hoy están listas, nos vemos mañana",
  "no cards to study, switch a deck on below": "no hay tarjetas pa' estudiar, activa un mazo abajo",
  "{seen} of {total} seen · {solid} solid": "{seen} de {total} vistas · {solid} firmes",
  "study {deck}": "estudiar {deck}",
  "could not load the deck": "no se pudo cargar el mazo",
  "could not save that answer": "no se pudo guardar esa respuesta",
  "could not save the deck setup": "no se pudo guardar la configuración del mazo",
  "basics": "lo básico",
  "favourites": "favoritos",
  "likes and goals": "gustos y metas",
  "looks": "aspecto",
  "identity": "identidad",
  "sexuality": "sexualidad",
  "story": "historia",
  "for chi": "para chi",
  "orientation": "orientación",
  "trivia": "curiosidades",
  "created by": "creado por",
  "world": "mundo",
  "location": "ubicación",
  "race": "raza",
  "occupation": "ocupación",
  "gender": "género",
  "height": "altura",
  "favourite food": "comida favorita",
  "smell": "olor",
  "pet peeve": "manía",
  "likes": "gustos",
  "dislikes": "disgustos",
  "look in short": "aspecto en breve",
  "body": "cuerpo",
  "clothes": "ropa",
  "visual features": "rasgos visuales",
  "speaking": "forma de hablar",
  "personality": "personalidad",
  "relationships": "relaciones",
  "items": "objetos",
  "skills": "habilidades",
  "preferences": "preferencias",
  "fetishes": "fetiches",
  "sexual trivia": "curiosidades sexuales",
  "rpg sheet": "ficha de rol",
  "fractal's notes for chi": "notas de fractal para chi",
  "sees your {kinds}": "ve tus {kinds}",
  "sees nothing of yours": "no ve na' tuyo",
  "{line}, adds to your {kinds}": "{line}, agrega a tus {kinds}",
  "{name} can add to your {kind}": "{name} puede agregar a tus {kind}",
  "{name} can only read your {kind}": "{name} solo puede leer tus {kind}",
  "{name} can see your {kind}": "{name} puede ver tus {kind}",
  "{kind} hidden from {name}": "{kind} ocultos para {name}",
  "{name} can see everything you can share": "{name} puede ver todo lo que puedes compartir",
  "{name} sees nothing of yours now": "{name} ya no ve na' tuyo",
  "share {kind} with {name}": "compartir {kind} con {name}",
  "you don't have notes, pings or anything else to share yet": "aún no tení notas, avisos ni nada pa' compartir",
  "share all": "compartir todo",
  "share none": "no compartir nada",
  "nobody else is in chix yet": "aún no hay nadie más en chix",
  "shares their {kinds}": "comparte sus {kinds}",
  "Calendar events": "Eventos del calendario",
  "Places and routes": "Lugares y rutas",
  "your sticky notes": "tus notas adhesivas",
  "reminders, alarms and timers": "recordatorios, alarmas y temporizadores",
  "your own events on the month": "tus propios eventos del mes",
  "plane and chix bot": "plane y el bot de chix",
  "clients, prices, status, linked tasks and money stats": "clientes, precios, estado, tareas vinculadas y estadísticas de dinero",
  "bills, costs, debts and goals": "facturas, gastos, deudas y metas",
  "what you keep up and your streaks": "lo que mantienes y tus rachas",
  "spots and routes you saved on the map": "lugares y rutas que guardaste en el mapa",
  "Can add to it": "Puede agregar",
  "bills, costs, money in and payments, with their name on them. they can change only what they added": "cuentas, gastos, plata que entra y pagos, con su nombre. solo pueden cambiar lo que agregaron",
  "off": "no",
  "{on} of {total} on · chi {spent} of {cap}": "{on} de {total} activados · chi {spent} de {cap}",
  "{on} of {total} on · chi {spent}": "{on} de {total} activados · chi {spent}",
  "{feature} off for {name}": "{feature} desactivado para {name}",
  "{name} can view {feature}": "{name} puede ver {feature}",
  "{name} can edit {feature}": "{name} puede editar {feature}",
  "{feature} for {name}": "{feature} para {name}",
  "monthly chi cap, usd": "límite mensual de chi, usd",
  "{name}'s chi stops at {amount} a month": "el chi de {name} se detiene en {amount} al mes",
  "no cap for {name}": "sin límite para {name}",
  "{spent} over {count} answers this month. 0 means no cap": "{spent} en {count} respuestas este mes. 0 significa sin límite",
  "remove {name}? they get signed out. their own notes and chats stay on the server if you add them back": "¿sacar a {name}? se le cierra la sesión. sus notas y chats se quedan en el servidor si lo volvís a agregar",
  "{name} removed": "{name} sacado",
  "just you for now": "solo tú por ahora",
  "{name} can sign in now. they start with chi, notes, pings and routines": "{name} ya puede entrar. parte con chi, notas, avisos y rutinas",
  "Calendar and pings": "Calendario y avisos",
  "Chi speaker": "Altavoz de Chi",
  "Discord messages": "Mensajes de discord",
  "Keys and server setup": "Claves y ajustes del servidor",
  "their own chat and memory, on your claude account": "su propio chat y memoria, en tu cuenta de claude",
  "the shared ref library": "la biblioteca compartida de refs",
  "the shared oc sheets": "las fichas de oc compartidas",
  "their own": "los suyos",
  "plane and chix bot, their own": "plane y el bot de chix, los suyos",
  "timer, palette, prompts, comms and their money stats": "temporizador, paleta, ideas, encargos y sus estadísticas de dinero",
  "their own bills, costs, debts and goals": "sus propias facturas, gastos, deudas y metas",
  "places nearby, routes and their saved spots, on your google maps key": "lugares cercanos, rutas y sus lugares guardados, con tu clave de google maps",
  "gesture drawing and japanese": "dibujo de gestos y japonés",
  "the shared doodle wall": "el muro de garabatos compartido",
  "their own scan library": "su propia biblioteca de escaneos",
  "their pings ring at home, chi answers their voice": "sus avisos suenan en casa, chi responde a su voz",
  "chi can dm your contacts for them": "chi puede escribir por dm a tus contactos por ellos",
  "vps panel and bot controls": "panel del vps y controles del bot",
  "every log line": "cada línea de registro",
  "spend and billing": "gasto y facturación",
  "api keys, ssh": "claves de api, ssh",
  "this dashboard": "este panel",
  "tap to upload": "toca para subir",
  "{count} kept": "{count} guardados",
  "uploading {n} of {total}": "subiendo {n} de {total}",
  "scan kept": "escaneo guardado",
  "{count} scans kept": "{count} escaneos guardados",
  "upload failed": "falló la subida, qué fome",
  "the brother is scanning": "la brother está escaneando",
  "scan failed": "falló el escaneo, qué fome",
  "saving {n} of {total}": "guardando {n} de {total}",
  "added to scans": "agregado a escaneos",
  "could not save that": "no se pudo guardar eso",
  "pdf scan, use download to open it": "escaneo pdf, usa descargar para abrirlo",
  "delete this scan?": "¿borrar este escaneo?",
  "days apart": "días entre medias",
  "times a week, any days": "veces por semana, cualquier día",
  "day of the month": "día del mes",
  "added by another part of chix, ticked off there too": "agregada por otra parte de chix, se marca allí también",
  "delete {title} and its history?": "¿borrar {title} y su historial?",
  "no routines": "sin rutinas",
  "ChiX routine": "Rutina de ChiX",
  "time for {title}": "hora de {title}",
  "weekdays": "entre semana",
  "every {n} days": "cada {n} días",
  "{n}x a week": "{n} veces por semana",
  "monthly on day {day}": "cada mes el día {day}",
  "{done}/{times} this week": "{done}/{times} esta semana",
  "ping {time}": "aviso {time}",
  "{n}w streak": "racha de {n} sem",
  "{n} streak": "racha de {n}",
  "{title} done": "{title} listo",
  "sticky {date}": "nota {date}",
  "saved {time}": "guardado {time}",
  "nothing coming up": "nada pa' pronto",
  "edit chix task": "editar tarea chix",
  "new chix task": "nueva tarea chix",
  "saving...": "guardando...",
  "mark \"{title}\" as done?": "¿marcar \"{title}\" como hecha?",
  "urgent": "urgente",
  "high": "alta",
  "medium": "media",
  "low": "baja",
  "{count} shown, updated {time}": "{count} mostradas, actualizado {time}",
  "nothing pending": "nada pendiente, filete",
  "night": "noche",
  "fog": "niebla",
  "ember": "brasa",
  "abyss": "abismo",
  "petal": "pétalo",
  "peach": "durazno",
  "mint": "menta",
  "lilac": "lila",
  "starlight": "luz estelar",
  "venom": "veneno",
  "pocket": "bolsillo",
  "{title} reached, tap done to cross it off": "{title} alcanzada, toca hecho para tacharla",
  "delete {title}? it won't come back": "¿borrar {title}? no volverá",
  "done · {n}": "hechas · {n}",
  "no goals": "sin metas",
  "this one's done, saving keeps it crossed out": "esta ya está hecha, al guardar sigue tachada",
  "no goals on the go": "ninguna meta en marcha",
  "add a couple of options": "agrega un par de opciones",
  "last one standing: {label}": "la última en pie: {label}",
  "everything's been knocked out": "se eliminó todo, quedó la escoba",
  "spinning": "girando",
  "the wheel says": "la ruleta dice",
  "new wheel": "nueva rueda",
  "knocked out": "eliminada",
  "{n} on the wheel, {out} knocked out": "{n} en la ruleta, {out} eliminadas",
  "{n} on the wheel": "{n} en la ruleta",
  "just now": "recién",
  "{n}m ago": "hace {n} min",
  "{n}h ago": "hace {n} h",
  "ready": "listo",
  "flick the wheel or press spin": "lanza la ruleta o aprieta girar",
  "add a couple of options to spin": "agrega un par de opciones pa' girar",
  "a wheel holds {max} options": "una ruleta admite {max} opciones",
  "only {room} fit, a wheel holds {max}": "solo caben {room}, una ruleta admite {max}",
  "my characters": "mis personajes",
  "there aren't enough characters yet": "aún no hay suficientes personajes",
  "which oc": "qué oc",
  "{name} copy": "{name} copia",
  "delete the wheel \"{name}\"?": "¿borrar la ruleta \"{name}\"?",
  "yes or no": "sí o no",
  "what to draw": "qué dibujar",
  "dinner": "cena",
  "dice": "dado",
  "who does it": "quién lo hace",
  "yes": "sí",
  "gesture warm up": "calentamiento de gestos",
  "portrait": "retrato",
  "an oc": "un oc",
  "hands and feet": "manos y pies",
  "background": "fondo",
  "comic page": "página de cómic",
  "redraw an old piece": "redibujar una obra antigua",
  "burgers": "completos y hamburguesas",
  "noodles": "fideos",
  "cook something": "cocinar algo",
  "yellow": "amarillo",
  "orange": "naranja",
  "lime": "lima",
  "teal": "verde azulado",
  "blue": "azul",
  "purple": "morado",
  "pink": "rosa",
  "white": "blanco",
  "black": "negro",
  "sky": "cielo",
  "slate": "pizarra",
  "edit message": "editar mensaje",
  "delete your message? it goes for everyone": "¿borrar tu mensaje? se borra pa' todos",
  "delete {name}'s message? it goes for everyone": "¿borrar el mensaje de {name}? se borra pa' todos",
  "couldn't delete that": "no se pudo borrar",
  "couldn't post that": "no se pudo publicar",
  "1 message": "1 mensaje",
  "{n} messages": "{n} mensajes",
  "someone": "alguien",
  "edited": "editado",
  "now": "ahora",
  "{n}m": "{n} min",
  "{n}h": "{n} h",
  "+{n} more": "+{n} más",
  "couldn't switch": "no se pudo cambiar",
  "switch": "cambiar",
  "profile": "perfil",
  "that isn't a picture": "eso no es una imagen",
  "picture saved": "imagen guardada",
  "upload picture": "subir imagen",
  "use {name}'s discord picture": "usar la imagen de discord de {name}",
  "remove picture": "quitar imagen",
  "owned by": "propiedad de",
  "remove {name} as an owner": "quitar a {name} como propietario",
  "owner removed": "propietario quitado",
  "another discord user id": "otro id de usuario de discord",
  "discord user id": "id de usuario de discord",
  "add owner": "agregar propietario",
  "they can sign in as {name} now": "ya pueden entrar como {name}",
  "a discord account that owns an alter can sign in and switch to it, so give the alter's own account here": "una cuenta de discord que posee un alter puede entrar y cambiar a él, así que pon aquí la cuenta propia del alter",
  "she/her, they/them…": "ella, elle…",
  "a line about them": "una línea sobre ellos",
  "pronouns": "pronombres",
  "about": "acerca de",
  "be {name}": "ser {name}",
  "{name} is part of {system}": "{name} forma parte de {system}",
  "back to my profile": "volver a mi perfil",
  "remove {name}? their notes and chats stay on the server if you add them back": "¿sacar a {name}? sus notas y chats se quedan en el servidor si lo volvís a agregar",
  "no alters yet. add the first one above": "aún no hay alters. agrega el primero arriba",
  "{name} added": "{name} agregado",
  "size: {size}, change": "tamaño: {size}, cambiar",
  "small": "pequeña",
  "half": "medio",
  "wide": "ancho",
  "hide": "ocultar",
  "move earlier": "mover antes",
  "move later": "mover después",
  "hold to drag": "mantén apretado pa' arrastrar",
  "arrange home": "ordenar inicio",
  "ask chi": "pregunta a chi",
  "inbox": "bandeja",
  "gauges": "indicadores",
  "message board": "tablón de mensajes",
  "spin": "girar",
  "{n} lines": "{n} trazos",
  "live": "en vivo",
  "no shared boards yet. make one and everyone can draw on it together": "aún no hay pizarras compartidas. crea una y todos dibujan juntos po",
  "no shared boards yet. Fractal can make one": "aún no hay pizarras compartidas. Fractal puede crear una",
  "{shared} shared · {mine} yours": "{shared} compartidas · {mine} tuyas",
  "could not load the boards": "no se pudieron cargar las pizarras",
  "could not make a board": "no se pudo crear la pizarra",
  "that board was deleted": "esa pizarra se borró",
  "shared board": "pizarra compartida",
  "board": "tablero",
  "offline, will send when back": "sin conexión, se manda cuando vuelva",
  "that's someone else's, only they can change it": "eso es de otra persona, solo esa persona lo puede cambiar",
  "lost the board": "se perdió la pizarra",
  "that layer is hidden, show it to draw": "esa capa está oculta, muéstrala para dibujar",
  "that layer is hidden, show it to write": "esa capa está oculta, muéstrala para escribir",
  "that layer is locked": "esa capa está bloqueada",
  "that layer is {who}'s, ask them to let you draw on it": "esa capa es de {who}, pídele que te deje dibujar en ella",
  "that layer has other people's lines, use the stroke eraser": "esa capa tiene trazos de otras personas, usa el borrador de trazos",
  "pencil found, fingers now move the board": "lápiz detectado, ahora los dedos mueven la pizarra",
  "{n} frames": "{n} fotogramas",
  "open": "abrir",
  "empty": "vacía",
  "this layer is yours": "esta capa es tuya",
  "{who}'s layer": "capa de {who}",
  ", open to everyone": ", abierta a todos",
  ", only they draw here": ", solo esa persona dibuja aquí",
  "frames": "fotogramas",
  "animate": "animar",
  "layer {n}": "capa {n}",
  "delete {name}? you can undo it": "¿borrar {name}? se puede deshacer",
  "{name} cleared, undo brings it back": "{name} vaciada, deshacer la recupera",
  "{n} frames is the most a layer holds": "una capa admite {n} fotogramas como máximo",
  "delete frame {n}? you can undo it": "¿borrar el fotograma {n}? se puede deshacer",
  "frame {n}": "fotograma {n}",
  "frames per second": "fotogramas por segundo",
  "onion skin {state}": "papel cebolla {state}",
  "shared · look only": "compartida · solo ver",
  "shared · live": "compartida · en vivo",
  "private": "privada",
  "paper {color}": "papel {color}",
  "could not make the picture": "no se pudo crear la imagen",
  "draw something first": "dibuja algo primero po",
  "posted to the doodle wall": "publicado en el muro de garabatos",
  "could not post it": "no se pudo publicar",
  "delete {name}? this can't be undone": "¿borrar {name}? no se puede deshacer",
  "delete {name}? this can't be undone, and it goes for everyone": "¿borrar {name}? no se puede deshacer y se borra para todos",
  "could not delete it": "no se pudo borrar",
  "could not open that board": "no se pudo abrir esa pizarra",
  "brush": "pincel",
  "erase": "borrar",
  "select": "elegir",
  "shape": "forma",
  "text": "texto",
  "move": "mover",
  "line": "línea",
  "arrow": "flecha",
  "box": "caja",
  "ellipse": "elipse",
  "rub out": "frotar",
  "whole strokes": "trazos enteros",
  "duplicate": "duplicar",
  "delete": "borrar",
  "done": "listo",
  "drag to pick, tap one stroke": "arrastra para elegir, toca un trazo",
  "show": "mostrar",
  "lock": "bloquear",
  "unlock": "desbloquear",
  "move up": "subir",
  "move down": "bajar",
  "stop playing": "parar",
  "play this layer": "reproducir esta capa",
  "previous frame": "fotograma anterior",
  "next frame": "fotograma siguiente",
  "new empty frame": "fotograma vacío nuevo",
  "copy this frame": "copiar este fotograma",
  "delete this frame": "borrar este fotograma",
  "move this frame earlier": "mover este fotograma antes",
  "move this frame later": "mover este fotograma después",
  "plain": "liso",
  "lines": "líneas",
  "pen": "lápiz pasta",
  "pencil": "lápiz",
  "ink": "tinta",
  "marker": "plumón",
  "glow": "brillo",
  "eraser": "borrador",
  "water": "agua",
  "air": "aire",
  "spray": "aerosol",
  "coal": "carbón",
  "chalk": "tiza",
  "crayon": "lápiz de cera",
  "rainbow": "arcoíris",
  "glitter": "brillantina",
  "neon": "neón",
  "boil": "hervir",
  "wave": "onda",
  "flame": "llama",
  "march": "marcha",
  "pulse": "pulso",
  "draw": "dibujo",
  "paint": "pintura",
  "texture": "textura",
  "steady": "estable",
  "pressure": "presión",
  "soft": "suave",
  "spread": "dispersión",
  "reset this brush": "restablecer este pincel",
  "multiply": "multiplicar",
  "screen": "trama",
  "overlay": "superponer",
  "soft light": "luz suave",
  "hard light": "luz fuerte",
  "darken": "oscurecer",
  "lighten": "aclarar",
  "color dodge": "sobreexponer color",
  "color burn": "subexponer color",
  "difference": "diferencia",
  "exclusion": "exclusión",
  "Goals": "Metas",
  "me": "yo",
  "Profile": "Perfil",
  "Message board": "Tablero de mensajes",
  "Roulette": "Ruleta",
  "Whiteboards": "Pizarras",
  "nothing on the board yet": "aún no hay nada en el tablero",
  "add to a": "agregar a un",
  "default": "predeterminado",
  "out of": "de",
  "no goals yet. add one for a chapter to finish, a page count to hit or anything you're working towards": "aún no hay metas. agrega una pa' un capítulo por terminar, un número de páginas o lo que andes persiguiendo",
  "kana is the standard gojūon table. kanji are the 2,211 jlpt n5 to n1 kanji, meanings and readings from kanjidic2 (edrdg, cc by-sa 4.0), levels from jonathan waller's jlpt lists (cc by)": "el kana es la tabla gojūon estándar. los kanji son los 2.211 kanji del jlpt n5 a n1, con significados y lecturas de kanjidic2 (edrdg, cc by-sa 4.0) y niveles de las listas jlpt de jonathan waller (cc by)",
  "bring all back": "traer todo de vuelta",
  "slices": "porciones",
  "history": "historial",
  "options": "opciones",
  "pasting a list adds them all. pizza *3 makes pizza three times as likely, and the weights below set it per slice": "pegar una lista los agrega todos. pizza *3 hace la pizza tres veces más probable, y los pesos de abajo lo ajustan por porción",
  "no options yet. add a few, or start from a preset in options": "aún no hay opciones. agrega algunas o parte con un preajuste en opciones",
  "shuffle": "mezclar",
  "even odds": "mismas probabilidades",
  "theme colours": "colores del tema",
  "tally": "recuento",
  "last spins": "últimos giros",
  "nothing spun on this wheel yet": "aún no se ha girado esta ruleta",
  "after a spin": "después de girar",
  "keep it": "dejarlo",
  "knock it out": "eliminarlo",
  "knock it out takes each winner off the wheel until you bring them all back, good for turns and tournaments": "eliminarlo saca a cada ganador de la rueda hasta que los traigas de vuelta, ideal para turnos y torneos",
  "spin length": "duración del giro",
  "quick": "rápido",
  "clicks and a jingle": "clics y una melodía",
  "new wheel from": "nueva rueda desde",
  "copy this wheel": "copiar esta rueda",
  "delete wheel": "borrar rueda",
  "winners are picked with your device's secure random, in proportion to each slice's weight, so a slice that looks twice as big really is twice as likely": "los ganadores se eligen con el aleatorio seguro de tu dispositivo, en proporción al peso de cada porción, así que una porción que se ve el doble de grande de verdad es el doble de probable",
  "wheel": "rueda",
  "the wheel, flick it to spin": "la rueda, lánzala para girar",
  "add options, one per line": "agrega opciones, una por línea",
  "option": "opción",
  "weight": "peso",
  "less likely": "menos probable",
  "more likely": "más probable",
  "less": "menos",
  "more": "más",
  "shared": "compartidas",
  "new board": "nueva pizarra",
  "mine · private": "mía · privada",
  "no boards of your own yet. only you ever see these": "aún no tienes pizarras propias. solo tú las ves",
  "layers": "capas",
  "opacity": "opacidad",
  "blend": "fusión",
  "let others draw on this layer": "dejar que otros dibujen en esta capa",
  "brush ·": "pincel ·",
  "pick from the board": "elegir del tablero",
  "recent": "recientes",
  "any colour": "cualquier color",
  "paper": "papel",
  "only the pencil draws, fingers move and zoom the board": "solo el lápiz dibuja, los dedos mueven y hacen zoom en el tablero",
  "fit": "ajustar",
  "save png": "guardar png",
  "post to doodles": "publicar en garabatos",
  "two fingers pinch and move, tap two fingers to undo, three to redo. on a keyboard: space drags, [ and ] size, ⌘z undo, k brushes, x erases whole strokes, t text, v select, u shapes, comma and full stop step frames, backslash plays": "dos dedos pellizcan y mueven, toca con dos dedos para deshacer, con tres para rehacer. con teclado: espacio arrastra, [ y ] tamaño, ⌘z deshacer, k pinceles, x borra trazos enteros, t texto, v seleccionar, u formas, coma y punto cambian de fotograma, barra invertida reproduce",
  "delete board": "borrar pizarra",
  "Board": "Tablero",
  "everyone on chi sees this": "todos en chi ven esto",
  "nothing on the board yet. post the first line": "aún no hay nada en el tablero. publica la primera línea po",
  "who's here": "quién está aquí",
  "who is here": "quién está aquí",
  "jot to inbox": "apuntar en la bandeja",
  "say something to everyone": "dile algo a todos",
  "message for the board": "mensaje para el tablero",
  "finish the chapter 2 sprites…": "terminar los sprites del capítulo 2…",
  "why, or what done looks like, optional": "por qué, o cómo se ve terminado, opcional",
  "progress": "progreso",
  "counting what": "contando qué",
  "a board everyone can draw on together": "una pizarra donde todos pueden dibujar juntos",
  "a board only you can see": "una pizarra que solo tú ves",
  "text on the board": "texto en el tablero",
  "back to the boards": "volver a las pizarras",
  "undo, or tap with two fingers": "deshacer, o toca con dos dedos",
  "redo": "rehacer",
  "redo, or tap with three fingers": "rehacer, o toca con tres dedos",
  "fit the drawing on screen": "ajustar el dibujo a la pantalla",
  "fit to the drawing": "ajustar al dibujo",
  "board settings": "ajustes de la pizarra",
  "brush size": "tamaño del pincel",
  "say something to everyone…": "dile algo a todos…",
  "new alter name": "nombre del nuevo alter",
  "all {count} presets are taken, unpin one first": "los {count} preajustes están ocupados, suelta uno primero",
  "could not change the owner": "no se pudo cambiar el dueño",
  "description": "descripción",
  "groups": "grupos",
  "large": "grande",
  "layout": "diseño",
  "mine {n}": "mías {n}",
  "owners": "dueños",
  "presets": "preajustes",
  "reversed": "invertido",
  "sort by": "ordenar por",
  "tap the star on a key to pin it. pins sit above the dock as presets": "toca la estrella de una tecla para fijarla. las fijadas quedan sobre el dock como preajustes",
  "unknown date": "fecha desconocida",
  "{name} is not yours any more": "{name} ya no es tuyo",
  "{name} is yours now": "{name} ahora es tuyo",
  "Grid": "Cuadrícula",
  "Masonry": "Mosaico",
  "Rows": "Filas",
  "Big grid": "Cuadrícula grande",
  "Wall": "Muro",
  "Posts": "Publicaciones",
  "Shuffle": "Mezclar",
  "random order, rolled once while it is open": "orden aleatorio, sorteado una vez mientras está abierto",
  "Newest": "Más recientes",
  "latest saved first": "lo último guardado primero",
  "Oldest": "Más antiguos",
  "earliest saved first": "lo primero guardado primero",
  "Most tagged": "Más etiquetados",
  "refs with the most tags first": "primero las refs con más etiquetas",
  "Undescribed first": "Sin descripción primero",
  "what has no description yet comes first": "lo que aún no tiene descripción va primero",
  "By tag": "Por etiqueta",
  "grouped under the most used tag": "agrupadas bajo la etiqueta más usada",
  "By author": "Por autor",
  "grouped A to Z": "agrupadas de la A a la Z",
  "By month": "Por mes",
  "grouped by the month you saved them": "agrupadas por el mes en que las guardaste",
  "By type": "Por tipo",
  "stills, gifs and clips apart": "imágenes, gifs y clips por separado",
  "sign in with discord · fractal and pauline": "entra con discord · fractal y pauline",
  "continue with discord": "seguir con discord",
  "use": "usar",
  "Ready when you are.": "Lista cuando querai.",
  "unit": "unidad",
  "chi · online": "chi · en línea, al tiro",
  "clear": "clara",
  "tip of the day": "consejo del día",
  "another one": "otro po",
  "add to a budget": "agregar a un presupuesto",
  "every month": "cada mes",
  "up next": "lo que viene",
  "all tasks": "todas las tareas",
  "nothing due, go draw": "nada pendiente, a dibujar po",
  "routines": "rutinas",
  "routines done for today": "rutinas listas por hoy",
  "notes": "notas",
  "no notes yet": "aún no hay notas",
  "Tasks": "Tareas",
  "chix task": "tarea chix",
  "Notes": "Notas",
  "note": "nota",
  "scratchpad": "borrador",
  "edit": "editar",
  "view": "ver",
  "random": "al azar",
  "newest": "más nuevos",
  "oldest": "más antiguos",
  "by tag": "por etiqueta",
  "stills": "imágenes",
  "moving": "animados",
  "chi's description": "descripción de chi",
  "your note": "tu nota",
  "ctrl+enter saves and goes next": "ctrl+enter guarda y pasa a la siguiente",
  "edit tags": "editar etiquetas",
  "close": "cerrar",
  "next": "siguiente",
  "Chi online. What are we drawing?": "Chi en línea. ¿Qué dibujamos, po?",
  "what should I work on?": "¿en qué debería pegarme?",
  "pose refs": "refs de poses",
  "pick an oc": "elige un oc",
  "comms": "encargos",
  "Routines": "Rutinas",
  "routine": "rutina",
  "every day": "cada día",
  "on these days": "estos días",
  "every few days": "cada pocos días",
  "times a week": "veces por semana",
  "once a month": "una vez al mes",
  "mon": "lun",
  "tue": "mar",
  "wed": "mié",
  "thu": "jue",
  "fri": "vie",
  "sat": "sáb",
  "sun": "dom",
  "ping at": "aviso a las",
  "paused": "en pausa",
  "cancel": "cancelar",
  "nothing on today": "nada pa' hoy",
  "other days": "otros días",
  "no routines yet. add one for a daily sketch, a weekly stream or anything you want to keep up": "aún no hay rutinas. agrega una pa' un boceto diario, un stream semanal o lo que quieras mantener",
  "Pings": "Avisos",
  "reminder": "recordatorio",
  "alarm": "alarma",
  "timer": "temporizador",
  "once": "una vez",
  "daily": "diario",
  "weekly": "semanal",
  "set": "poner",
  "no pings yet. set one for a stream, a deadline or a break": "aún no hay avisos. pon uno pa' un stream, una entrega o un descanso",
  "Session": "Sesión",
  "focus": "concentración",
  "start": "partir",
  "tap the time to type your own, like 40 or 1h30": "toca la hora pa' escribir la tuya, como 40 o 1h30",
  "0 blocks today": "0 bloques hoy",
  "Palette": "Paleta",
  "keep": "guardar",
  "tap a swatch to copy it, hold to toss it": "toca un color pa' copiarlo, mantén pa' botarlo",
  "save prompt": "guardar prompt",
  "tap a card to copy the whole prompt": "toca una tarjeta pa' copiar el prompt entero",
  "Comms": "Encargos",
  "tap a commission to edit it": "toca un encargo pa' editarlo",
  "list": "lista",
  "money": "plata",
  "new commission": "nuevo encargo",
  "sketch": "boceto",
  "wip": "en curso",
  "review": "revisión",
  "reference pics": "imágenes de referencia",
  "this month": "este mes",
  "this year": "este año",
  "to be paid": "por cobrar",
  "paid by month": "cobrado por mes",
  "by client": "por cliente",
  "by status": "por estado",
  "a commission counts on the day it was marked paid. change that day on its card": "un encargo cuenta el día en que se marcó pagado. cambia ese día en su tarjeta",
  "Budget": "Presupuesto",
  "left": "queda",
  "in and out": "entra y sale",
  "monthly by category": "mensual por categoría",
  "debts and goals": "deudas y metas",
  "one off": "puntual",
  "monthly": "mensual",
  "bills": "cuentas",
  "costs": "gastos",
  "debts": "deudas",
  "goals": "metas",
  "nothing here yet. add a bill, a debt or a goal above": "aún no hay nada. agrega una cuenta, una deuda o una meta arriba",
  "only you see this unless you switch it on for someone in sharing. paid commissions count as money in": "solo tú ves esto, salvo que lo actives pa' alguien en compartir. los encargos pagados cuentan como plata que entra",
  "Gesture": "Gesto",
  "timed poses, draw fast, the next one drops in on its own": "poses cronometradas, dibuja rápido, la siguiente llega sola",
  "source": "fuente",
  "full body": "cuerpo entero",
  "my refs": "mis refs",
  "each pose": "cada pose",
  "pause": "pausa",
  "skip": "saltar",
  "Japanese": "Japonés",
  "learning": "aprendiendo",
  "show answer": "ver respuesta",
  "again": "otra vez",
  "hard": "difícil",
  "good": "bien",
  "easy": "fácil",
  "space shows the answer, 1 to 4 grades it": "espacio muestra la respuesta, 1 a 4 la califica",
  "decks": "mazos",
  "new cards a day": "cartas nuevas al día",
  "study, new cards come in this order": "estudio, las cartas nuevas llegan en este orden",
  "Characters": "Personajes",
  "chi look": "mirada de chi",
  "no characters match": "ningún personaje coincide",
  "new character": "nuevo personaje",
  "name": "nombre",
  "tags, comma separated": "etiquetas, separadas por comas",
  "sheet picture": "imagen de ficha",
  "character file": "archivo del personaje",
  "chi saw": "chi vio",
  "use as picture": "usar como imagen",
  "add pic": "agregar imagen",
  "drop pic": "quitar imagen",
  "merge": "fusionar",
  "merge into": "fusionar con",
  "pick the same character under another name. its pictures and anything this sheet is missing move here, and imports will update this sheet from then on.": "elige el mismo personaje con otro nombre. sus imágenes y lo que le falte a esta ficha pasan aquí, y desde entonces las importaciones actualizarán esta ficha.",
  "Calendar": "Calendario",
  "Maps": "Mapas",
  "near me": "cerca de mí",
  "maps needs a google key": "mapas necesita una clave de google",
  "in console.cloud.google.com make a project and turn on billing": "en console.cloud.google.com crea un proyecto y activa la facturación",
  "turn on": "activa",
  "and": "y",
  "make an api key under credentials, and limit it to those three apis": "crea una clave de api en credenciales y limítala a esas tres apis",
  "paste it in setup, keys, google maps. or put it on the server as GOOGLE_MAPS_API_KEY": "pégala en ajustes, claves, google maps. o ponla en el servidor como GOOGLE_MAPS_API_KEY",
  "open setup": "abrir ajustes",
  "search this area": "buscar en esta zona",
  "route here": "ruta hasta aquí",
  "route from": "ruta desde",
  "remove": "sacar",
  "nearby": "cerca",
  "route": "ruta",
  "best rated": "mejor valorados",
  "most reviews": "más reseñas",
  "closest": "más cerca",
  "parking first": "estacionamiento primero",
  "add where you start and where you're going. places from nearby can go in with their route button": "agrega de dónde sales y a dónde vas. los lugares de cerca pueden entrar con su botón de ruta",
  "from here": "desde aquí",
  "home": "casa",
  "best order for the middle stops": "mejor orden para las paradas intermedias",
  "plan route": "planear ruta",
  "time": "tiempo",
  "distance": "distancia",
  "stops": "paradas",
  "pins": "pines",
  "tap drop a pin, then tap the map where it goes": "toca poner un pin y luego toca el mapa donde va",
  "pin where i am": "pin donde estoy",
  "places": "lugares",
  "star a place from nearby to keep it here": "marca con estrella un lugar de cerca para guardarlo aquí",
  "routes": "rutas",
  "plan a route and save it to keep it here": "planea una ruta y guárdala para tenerla aquí",
  "only you see these unless you switch places and routes on for someone in sharing": "solo tú ves esto salvo que actives lugares y rutas para alguien en compartir",
  "tape": "cinta",
  "Scans": "Escaneos",
  "photo": "foto",
  "scan": "escanear",
  "on this pc": "en este pc",
  "upload all": "subir todo",
  "scans the brother left in the inbox folder that the web cannot see yet": "escaneos que la brother dejó en la carpeta de entrada y que la web aún no ve",
  "no scans yet. scan on the pc, or snap a photo of a sketch": "aún no hay escaneos. escanea en el pc o haz una foto de un boceto",
  "Doodles": "Garabatos",
  "paste": "pegar",
  "no doodles yet. paste one, or add pictures from your phone": "aún no hay garabatos. pega uno o agrega imágenes desde tu celular",
  "doodle": "garabato",
  "title": "título",
  "drawn by": "dibujado por",
  "day": "día",
  "characters in it": "personajes que salen",
  "undo mine": "deshacer el mío",
  "newer": "más nuevo",
  "older": "más antiguo",
  "Server": "Servidor",
  "reload caddy": "recargar caddy",
  "memory": "memoria",
  "load": "carga",
  "bots up": "bots activos",
  "Logs": "Registros",
  "nothing happened yet, it shows up here live": "aún no pasa nada, aparece acá en vivo",
  "billing": "facturación",
  "month": "mes",
  "tags": "etiquetas",
  "key": "clave",
  "tagging": "etiquetado",
  "budget": "presupuesto",
  "batch": "lote",
  "by model": "por modelo",
  "by person": "por persona",
  "estimates from the token counts claude sends back. billing has the real bill": "estimaciones según los tokens que devuelve claude. la facturación tiene la cuenta real",
  "People": "Personas",
  "let in": "dejar entrar",
  "their chi": "su chi",
  "yours": "tuyo",
  "everyone talks to chi on your claude key. they never see it, their chats and memory stay their own, and their share of the bill is counted here": "todos hablan con chi con tu clave de claude. nunca la ven, sus chats y memoria son de ellos, y su parte de la cuenta se cuenta acá",
  "let someone in": "dejar entrar a alguien",
  "they sign in with discord. if they try before you add them, the page shows them their id to send you": "entran con discord. si lo intentan antes de que los agregues, la página les muestra su id pa' que te lo manden",
  "only you": "solo tú",
  "Sharing": "Compartir",
  "pick what each person can see. they can only read it, never change it. it shows up next to their own notes, pings and the rest, and their chi can read it too": "elige qué puede ver cada persona. solo pueden leerlo, nunca cambiarlo. aparece junto a sus propias notas, avisos y lo demás, y su chi también lo puede leer",
  "shared with you": "compartido contigo",
  "nobody shares anything with you yet": "aún nadie comparte nada contigo",
  "Setup": "Ajustes",
  "assistant": "asistente",
  "anthropic api key": "clave de api de anthropic",
  "chat model": "modelo de chat",
  "ref tagging model": "modelo de etiquetado de refs",
  "monthly tagging budget, usd": "presupuesto mensual de etiquetado, usd",
  "tagging pauses once the month's estimate passes the budget. 0 means no cap. claude-haiku-4-5 tags cheaper": "el etiquetado se pausa cuando la estimación del mes supera el presupuesto. 0 es sin límite. claude-haiku-4-5 etiqueta más barato",
  "currency": "moneda",
  "yours only. the sign shown on comms, money stats and the budget. auto reads it from what you type on commissions. it saves as soon as you pick": "solo tuya. el símbolo de los encargos, las estadísticas de plata y el presupuesto. auto lo lee de lo que escribes en los encargos. se guarda apenas eliges",
  "log into the plane tab, then connect": "entra a la pestaña de plane y después conecta",
  "open plane, make an api token in profile settings, paste it here": "abre plane, crea un token de api en ajustes del perfil y pégalo acá",
  "connect plane": "conectar plane",
  "workspace slug": "slug del espacio",
  "api key": "clave de api",
  "load boards": "cargar tableros",
  "chix bot": "bot chix",
  "api url": "url de la api",
  "your discord user id": "tu id de usuario de discord",
  "browser key, optional": "clave de navegador, opcional",
  "the api key searches places and plans routes from the server. the map itself loads with the browser key if there is one, otherwise the api key. GOOGLE_MAPS_API_KEY on the server wins over this": "la clave de api busca lugares y planea rutas desde el servidor. el mapa carga con la clave de navegador si hay una, si no con la de api. GOOGLE_MAPS_API_KEY en el servidor tiene prioridad",
  "server": "servidor",
  "bots folder": "carpeta de bots",
  "sudo password": "contraseña sudo",
  "ssh host": "host ssh",
  "ssh user": "usuario ssh",
  "ssh key file": "archivo de clave ssh",
  "browser extension": "extensión del navegador",
  "paste this into the extension options as the cloud token. it's yours, so saves land as you": "pega esto en las opciones de la extensión como token de la nube. es tuyo, así que lo guardado queda a tu nombre",
  "chrome: unzip over the old folder and hit reload in chrome://extensions. firefox: open the file in firefox and allow it, it updates itself after that": "chrome: descomprime encima de la carpeta vieja y dale a recargar en chrome://extensions. firefox: abre el archivo en firefox y permítelo, después se actualiza solo",
  "your extension token": "tu token de extensión",
  "copy": "copiar",
  "new token": "nuevo token",
  "links": "enlaces",
  "one per line as name | url. they open inside the desk app, or in a new tab on the web": "uno por línea como nombre | url. se abren dentro de la app de escritorio o en una pestaña nueva en la web",
  "desk": "escritorio",
  "cloud url": "url de la nube",
  "cloud token": "token de la nube",
  "chrome extension token": "token de la extensión de chrome",
  "brother scan folder": "carpeta de escaneos brother",
  "start with windows": "iniciar con windows",
  "security": "seguridad",
  "signs out every phone, tablet and browser that is logged in, including this one. use it if a device was lost or you think someone got in": "cierra la sesión en todos los celulares, tablets y navegadores conectados, este incluido. úsalo si perdiste un dispositivo o creís que alguien entró",
  "log out everywhere": "cerrar sesión en todas partes",
  "pick a look": "elige un estilo",
  "background pattern": "patrón de fondo",
  "film grain and fog": "grano de película y niebla",
  "calm motion": "movimiento suave",
  "retry": "reintentar",
  "toss": "botar",
  "logs": "registros",
  "paid on": "pagado el",
  "undo": "deshacer",
  "setup token": "token de configuración",
  "talk to chi": "hablar con chi",
  "jot into inbox": "apuntar en la bandeja",
  "whose budget": "presupuesto de quién",
  "what kind": "qué tipo",
  "what it is": "qué es",
  "ask chi…": "pregunta a chi…",
  "ask": "preguntar",
  "refresh": "actualizar",
  "find a task": "buscar una tarea",
  "just type, it saves itself": "escribe no más, se guarda solo",
  "search notes": "buscar notas",
  "back": "atrás",
  "print": "imprimir",
  "# heading\n\nmarkdown works, autosave is on": "# título\n\nmarkdown funciona, autoguardado activo",
  "search refs, tags, characters": "buscar refs, etiquetas, personajes",
  "tile size": "tamaño de mosaico",
  "add pictures": "agregar imágenes",
  "sort the feed": "ordenar el feed",
  "what you want to remember about this": "lo que quieres recordar de esto",
  "re-index": "reindexar",
  "open post": "abrir post",
  "message chi": "escribir a chi",
  "send": "enviar",
  "a sketch a day…": "un boceto al día…",
  "how often": "cada cuánto",
  "how many": "cuántas",
  "note, optional": "nota, opcional",
  "nudge me about…": "recuérdame…",
  "kind": "tipo",
  "set the time": "poner la hora",
  "minutes, like 40 or 1h30": "minutos, como 40 o 1h30",
  "reset": "reiniciar",
  "another tip": "otro consejo",
  "pick a colour": "elige un color",
  "name, like sitting nsfw": "nombre, como sentada nsfw",
  "piece": "pieza",
  "client (for the money stats)": "cliente (para las estadísticas de dinero)",
  "amount": "importe",
  "due": "entrega",
  "what they want drawn": "lo que quieren que dibujes",
  "previous month": "mes anterior",
  "next month": "mes siguiente",
  "what is it": "qué es",
  "owed": "debido",
  "category": "categoría",
  "only refs matching… (optional)": "solo refs que coincidan… (opcional)",
  "add the characters from zirk.eu/oc": "agregar los personajes de zirk.eu/oc",
  "add the characters from the discord character channel": "agregar los personajes del canal de personajes de discord",
  "chi looks at character pictures and writes tags and a line about each, so she picks better characters and refs": "chi mira las imágenes de los personajes y escribe etiquetas y una línea sobre cada uno, para elegir mejor personajes y refs",
  "search name, race, likes, fetishes…": "buscar nombre, raza, gustos, fetiches…",
  "search characters…": "buscar personajes…",
  "reload": "recargar",
  "add an event": "agregar un evento",
  "map": "mapa",
  "name it: studio, mum's, good parking": "ponle nombre: estudio, la casa de la mamá, buen estacionamiento",
  "a note, optional": "una nota, opcional",
  "colour": "color",
  "sushi, art supplies, an address": "sushi, materiales de arte, una dirección",
  "how far": "a qué distancia",
  "add a stop: address, postcode or place": "agrega una parada: dirección, código postal o lugar",
  "add stop": "agregar parada",
  "download": "descargar",
  "add the picture on your clipboard, or press ctrl+v": "agrega la imagen del portapapeles o aprieta ctrl+v",
  "search title, artist, character, tag…": "buscar título, artista, personaje, etiqueta…",
  "untitled": "sin título",
  "type a name to add a character": "escribe un nombre para agregar un personaje",
  "count a fap": "contar un fap",
  "console.anthropic.com, api keys": "console.anthropic.com, claves de api",
  "the part after the domain": "la parte después del dominio",
  "maps javascript, places (new) and routes": "maps javascript, places (new) y routes",
  "only if the map should load with its own key": "solo si el mapa debe cargar con su propia clave",
  "find a tool or place": "busca una herramienta o lugar",
  "what needs doing?": "¿qué hay que hacer?",
  "optional notes": "notas opcionales",
  "index": "índice",
  "mark done": "marcar hecho",
  "status": "estado",
  "link a task": "vincular una tarea",
  "find a plane or chix task": "busca una tarea de plane o chix",
  "take back the last one": "quitar el último",
  "take out": "sacar",
  "tasks": "tareas",
  "Today": "Hoy",
  "References": "Referencias",
  "describe": "describir",
  "Ask ChiX": "Pregunta a ChiX",
  "gesture": "gesto",
  "Gesture drawing": "Dibujo gestual",
  "Session timer": "Temporizador de sesión",
  "palette": "paleta",
  "Commissions": "Encargos",
  "maps": "mapas",
  "Calculator": "Calculadora",
  "doodles": "garabatos",
  "scans": "escaneos",
  "Claude usage": "Uso de Claude",
  "people": "personas",
  "share": "compartir",
  "setup": "ajustes",
  "keys": "claves",
  "themes": "temas",
  "studio": "estudio",
  "system": "sistema",
  "Home": "Inicio",
  "Studio": "Estudio",
  "Practice": "Práctica",
  "Ledger": "Cuentas",
  "Library": "Biblioteca",
  "Core": "Núcleo",
  "language": "idioma",
  "yours only. the app's words and chi's replies follow it. it saves as soon as you pick": "solo tuyo. los textos de la app y las respuestas de chi lo siguen. se guarda apenas eliges",
  "Quick note": "Nota rápida",
  "Reminders": "Recordatorios",
  "Ubuntu helpers": "Ayudas de Ubuntu",
  "Quit": "Salir",
  "open {name}": "abrir {name}",
  "sort": "orden",
  "this one is mine": "este es mío",
  "reverse the order": "invertir el orden",
  "filter": "filtro",
  "{name} can sign in now. they start with chi, notes, pings, routines and goals": "{name} ya puede entrar. parte con chi, notas, avisos, rutinas y metas"
};
